import mixpanel from "../services/mixpanel";

const interactionActionsTypesObject = {
  LIKE_POST_REQUEST: "post.like",
  UNLIKE_POST_REQUEST: "post.unlike",
  CREATE_COMMENT_REQUEST: "comment.create",
  FOLLOW_USER_REQUEST: "user.follow.request",
  UNFOLLOW_USER_REQUEST: "user.unfollow.request",
};
const InteractionsTracker = store => next => action => {
  if (Object.keys(interactionActionsTypesObject).includes(action.type)) {
    const state = store.getState();
    const currentPageTitle = state.router.result.title;
    const recommndedFromCase = state.router.query.recommended_from;
    const eventProperties = { eventSource: currentPageTitle };
    if (recommndedFromCase) {
      eventProperties.recommendedFrom = recommndedFromCase;
    }

    mixpanel.track(interactionActionsTypesObject[action.type], eventProperties);
  }
  next(action);
};

export default InteractionsTracker;



// WEBPACK FOOTER //
// ./src/middleware/InteractionsTracker.js